














































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {WarehouseStore} from "@/modules/warehouses/store";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: 'WarehouseSuggestDeliveryTable',
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() dataSource!: any;
    @PropSync('form') formSync!: any;

    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLading.ladingCode",
            key: "ladingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Mã vận đơn ĐT",
            dataIndex: "billLading.partnerLadingCode",
            key: "partnerLadingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "SĐT người nhận",
            dataIndex: "billLading.locationTo.phoneNumber",
            key: "locationToPhoneNumber",
            width: 150,
            ellipsis: true
        },
        {
            title: "Tên người nhận",
            dataIndex: "ladingRowGuid",
            key: "locationToName",
            scopedSlots: {customRender: "locationToName"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Địa chỉ nhận",
            dataIndex: "ladingRowGuid",
            key: "locationToAddress",
            scopedSlots: {customRender: "locationToAddress"},
            width: 500,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "ladingRowGuid",
            key: "ladingWeight",
            scopedSlots: {customRender: "ladingWeight"},
            width: 100,
            ellipsis: true
        },
        {
            title: "SK",
            dataIndex: "ladingRowGuid",
            key: "ladingBoxQuantity",
            scopedSlots: {customRender: "ladingBoxQuantity"},
            width: 80,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "billLading.freightService.serviceCode",
            key: "ladingFreightService",
            width: 100,
            ellipsis: true
        },
        {
            title: "DV_GTGT",
            dataIndex: "billLading.freightServiceAdds",
            key: "ladingFreightServiceAdd",
            scopedSlots: {customRender: 'ladingFreightServiceAdd'},
            width: 120,
            ellipsis: true
        },
        {
            title: "Thu tiền NN",
            dataIndex: "ladingRowGuid",
            key: "ladingCOD",
            scopedSlots: {customRender: "ladingCOD"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "ladingRowGuid",
            key: "ladingStatus",
            scopedSlots: {customRender: "ladingStatus"},
            width: 180,
            ellipsis: true
        }
    ];

    deleteWarehouse(id: number) {
        WarehouseStore.deleteWarehouse([id]);
        this.formSync.warehouseIds = this.formSync.warehouseIds.filter((warehouseId: number) => warehouseId != id);
    }

    onSelectChange(selectedRowKeys: string[]) {
        this.formSync.warehouseIds = selectedRowKeys as any;
    }
}
